import gql from "graphql-tag"

export const GET_ORDERS = gql`
  query Orders($take: Int, $skip: Int, $input: OrderFilterInput) {
    orders(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        orderNumber
        status
        totalAmount
        processTime
        submittedTime
        confirmedTime
        successTime
        cacelTime
        expectedDate
        updatedAt
        company {
          id
          name
        }
        user {
          id
          name
        }
      }
    }
  }
`

export const GET_ORDER = gql`
  query Order($id: ID!) {
    order(id: $id) {
      id
      orderNumber
      status
      totalAmount
      processTime
      submittedTime
      confirmedTime
      successTime
      clientOrderNumber
      cacelTime
      expectedDate
      updatedAt
      invoiceNumber
      deliveryNumber
      invoiceUrl
      deliveryType
      orderDetails {
        id
        product {
          id
          name
          category {
            id
            name
          }
          subcategory {
            id
            name
          }
        }
        quantity
        unitPrice
      }
      orderHistories {
        id
        description
        creator {
          id
          name
        }
      }
      company {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

export const SUM_ORDERS = gql`
  query Orders($input: OrderFilterInput) {
    orders(take: 0, input: $input) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query OrderFields {
    aorderFields @client {
      name
      title
      order
      show
    }
  }
`

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($id: ID!, $input: OrderUpdateInput!) {
    updateOrder(id: $id, input: $input) {
      id
    }
  }
`

export const UPDATE_ORDER_DETAILS = gql`
  mutation UpdateOrderDetails(
    $orderId: ID!
    $updateOrderDetailInputs: [UpdateOrderDetailInput!]!
  ) {
    updateOrderDetails(
      orderId: $orderId
      updateOrderDetailInputs: $updateOrderDetailInputs
    ) {
      id
    }
  }
`
